export const FACTORY_ADDRESS = '0x9E6d21E759A7A288b80eef94E4737D313D31c13f'
export const ROUTER_ADDRESS = '0xBb5e1777A331ED93E07cF043363e48d320eb96c4'
export const INIT_CODE_HASH = '0x58c1b429d0ffdb4407396ae8118c58fed54898473076d0394163ea2198f7c4a3'
